function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.87496 7.49984C6.87496 5.77395 8.27407 4.37484 9.99996 4.37484C11.7259 4.37484 13.125 5.77395 13.125 7.49984C13.125 9.22573 11.7259 10.6248 9.99996 10.6248C8.27407 10.6248 6.87496 9.22573 6.87496 7.49984ZM9.99996 5.62484C8.96443 5.62484 8.12496 6.4643 8.12496 7.49984C8.12496 8.53537 8.96443 9.37484 9.99996 9.37484C11.0355 9.37484 11.875 8.53537 11.875 7.49984C11.875 6.4643 11.0355 5.62484 9.99996 5.62484Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.04163 9.99984C1.04163 5.05229 5.05241 1.0415 9.99996 1.0415C14.9475 1.0415 18.9583 5.05229 18.9583 9.99984C18.9583 14.9474 14.9475 18.9582 9.99996 18.9582C5.05241 18.9582 1.04163 14.9474 1.04163 9.99984ZM9.99996 2.2915C5.74276 2.2915 2.29163 5.74264 2.29163 9.99984C2.29163 12.1212 3.14852 14.0423 4.53505 15.4361C4.68537 14.6252 4.98074 13.8606 5.5736 13.2458C6.4604 12.3261 7.87843 11.8748 9.99992 11.8748C12.1214 11.8748 13.5394 12.3261 14.4262 13.2458C15.0191 13.8606 15.3145 14.6252 15.4648 15.4362C16.8514 14.0424 17.7083 12.1212 17.7083 9.99984C17.7083 5.74264 14.2572 2.2915 9.99996 2.2915ZM14.328 16.3793C14.2431 15.3694 14.0238 14.6293 13.5264 14.1134C12.9852 13.5521 11.9824 13.1248 9.99992 13.1248C8.01745 13.1248 7.01464 13.5521 6.47341 14.1134C5.97602 14.6292 5.75672 15.3694 5.67181 16.3793C6.90566 17.218 8.39557 17.7082 9.99996 17.7082C11.6043 17.7082 13.0942 17.218 14.328 16.3793Z",
  fill: "currentColor"
}));

function SvgUserManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManager);
export default __webpack_public_path__ + "static/media/user-manager.f958bc97.svg";
export { ForwardRef as ReactComponent };